import { THEMES } from "../../config/constants";
import { inpStyle, lbl } from "../../utils/styles";

export default function ModalField({label,k,half,placeholder,multiline,type,value,onChange,theme}){
  const t=THEMES[theme];
  return(
    <div style={{flex:half?"1":"none",width:half?undefined:"100%",minWidth:0,marginBottom:12}}>
      <label style={{...lbl,color:t.textSub}}>{label}</label>
      {multiline
        ?<textarea style={{...inpStyle(t),minHeight:84,resize:"vertical"}} value={value||""} onChange={e=>onChange(k,e.target.value)} placeholder={placeholder||""}/>
        :<input style={inpStyle(t)} type={type||"text"} value={value||""} onChange={e=>onChange(k,e.target.value)} placeholder={placeholder||""}/>}
    </div>
  );
}
